import { AcademyFetchingClient } from 'academy-common-lib/utils/DataFetchingClient';
const dataFetchingClient = new AcademyFetchingClient({
  assumeImmutableResults: true
});
export default dataFetchingClient;